import { useEffect } from 'react';

import { useGetInvestorsQuery } from '../queries';
import { useEmployeeEnrollmentsStore } from '../stores/useEmployeeEnrollments.store';

// import { useEnrollmentsStatisticsQuery } from '../queries/useEnrollmentStatistics.query';
import { useGetEnrollments } from './useGetEnrollment';

export const useEnrollmentsData = (employeeId: string, status?: string | null) => {
  const {
    data: enrollments,
    isLoading,
    // isLoading: enrollmentsLoading,
  } = useGetEnrollments({
    employeeId,
    status,
  });
  const { formattedData: investorsData } = useGetInvestorsQuery(employeeId);
  const setEnrollments = useEmployeeEnrollmentsStore((state) => state.handleSetEnrollments);
  const setIsLoading = useEmployeeEnrollmentsStore((state) => state.handleSetIsLoading);
  const resetEnrollments = useEmployeeEnrollmentsStore((state) => state.handleReset);

  useEffect(() => {
    setEnrollments(enrollments);
    setIsLoading(isLoading);
  }, [enrollments, setEnrollments, isLoading, setIsLoading]);

  useEffect(
    () => () => {
      resetEnrollments();
    },
    [resetEnrollments]
  );

  return {
    enrollments,
    investorsData,
    isLoading,
  };
};
